import React, { PureComponent } from 'react';
import { uiComponents } from 'sis_ui/config';
const tags = uiComponents.tags;
const ErrorComponent = () => {
  return 'Something went wrong...';
}

export default class UIComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      Component: null,
      hasError: false,
    }
  }


  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  componentDidMount() {
    if(!this.state.Component && tags.hasOwnProperty(this.props.component)) {
      switch (this.props.component) {
        // case 'text':
        //   const Text = require('sis_ui/modules/internationalization/text')['Text'];
        //   this.setState( {Component: Text} );
        // break;
        // case 'attr-text':
        //   const AttrText = require('sis_ui/modules/internationalization/text')['AttrText'];
        //   this.setState( {Component: AttrText} );
        // break;
        default:
          tags[this.props.component]().then((Component) => {
            this.setState({ Component: Component.default })
          });
      }
    } else {
      if (!tags.hasOwnProperty(this.props.component)) {
        console.warn('Component ' + this.props.component + ' does not exist');
      }
    }
  }

  render() {
    let Component = null;
    if (this.state.hasError) {
      Component = ErrorComponent;
    } else {
      Component = this.state.Component;
    }
    return (
      <React.Fragment>
          {Component ? <Component {...this.props} device="mobile">{this.props.children}</Component> : ""}
      </React.Fragment>
    );
  }
};